import { Navigate, useLocation } from "react-router-dom";
import { useFontDesk } from "../context/frontDeskContext";
import { AdminUser, CoachUser } from "../utils/constants";
import { useEffect } from "react";

const PrivateRoute = ({ children }: any) => {
  const { isAuthenticated, staffModel, setInitialRoute } = useFontDesk();
  const { pathname, search } = useLocation();

  useEffect(() => {
    console.log("initial route pathname", pathname, "search", search);
    setInitialRoute(`${pathname}${search}`);
  }, []);

  if (isAuthenticated === null) {
    return <Navigate to={`${pathname}`} />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/otp-login" />;
  }

  if (staffModel?.role === CoachUser.value) {
    if (CoachUser.paths.includes(pathname)) {
      return children;
    } else {
      return <Navigate to="/" />;
    }
  }

  if (staffModel?.role === AdminUser.value) {
    if (AdminUser.paths.includes(pathname)) {
      return children;
    } else {
      return <Navigate to="/" />;
    }
  }
};

export default PrivateRoute;
